import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3f8e624"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card__avatar" }
const _hoisted_2 = {
  key: 2,
  class: "avatar__button p-p-2"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "avatar-info" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass('avatar-info__name')
}
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass('text-light-gray')
}
const _hoisted_7 = { class: "p-d-flex p-flex-column" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { for: "searchBar" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-field" }, " *", -1))
const _hoisted_11 = { class: "overlaypanel-content" }
const _hoisted_12 = { class: "p-input-icon-left" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "filler"
}
const _hoisted_15 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_16 = {
  key: 0,
  class: "required-field"
}
const _hoisted_17 = {
  key: 3,
  class: "input-helper"
}
const _hoisted_18 = {
  key: 4,
  class: "error-msg"
}
const _hoisted_19 = {
  key: 0,
  class: "container-input p-d-flex p-flex-column"
}
const _hoisted_20 = { class: "p3 text-light-gray p-mb-1" }
const _hoisted_21 = { class: "p-inputtext p-component p-filled input-form-student input-form-student" }
const _hoisted_22 = {
  key: 2,
  class: "full-width"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_custom_transition = _resolveComponent("custom-transition")!
  const _component_SkeletonIcon = _resolveComponent("SkeletonIcon")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Camera = _resolveComponent("Camera")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createVNode(_component_Dialog, {
      class: "profile-dialog",
      visible: _ctx.changePasswordRefs.dialogOpen,
      modal: true,
      "onUpdate:visible": _ctx.changePasswordHandlers.cancel
    }, {
      header: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString(_ctx.t('changePassword.dialog.title')), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.t('changePassword.dialog.cancel'),
          disabled: _ctx.changePasswordRefs.loading,
          class: "secondary",
          onClick: _ctx.changePasswordHandlers.cancel
        }, null, 8, ["label", "disabled", "onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.t('changePassword.dialog.confirm'),
          disabled: _ctx.changePasswordRefs.loading,
          loading: _ctx.changePasswordRefs.loading,
          onClick: _ctx.changePasswordHandlers.confirm
        }, null, 8, ["label", "disabled", "loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(_ctx.t('changePassword.dialog.subtitle', { at: '@' })) + " ", 1)
      ]),
      _: 1
    }, 8, ["visible", "onUpdate:visible"]),
    _createVNode(_component_custom_transition, null, {
      default: _withCtx(() => [
        (_ctx.editingProfile)
          ? (_openBlock(), _createBlock(_component_Breadcrumb, {
              key: 0,
              class: "p-mb-3 p-ml-2 p-mt-3",
              home: { label: _ctx.t('editProfile.breadCrumb.title1'), command: _ctx.handleToggleEdit },
              model: [{ label: _ctx.t('editProfile.breadCrumb.title2'), to: '/profile' }]
            }, null, 8, ["home", "model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_card, {
      class: "card-student",
      style: _normalizeStyle(_ctx.editingProfile && 'background: inherit')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["p-d-flex p-ai-center p-flex-row card__header", 'container-avatar'])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loadingUpdateImage)
              ? (_openBlock(), _createBlock(_component_SkeletonIcon, {
                  key: 0,
                  class: "avatar__skeleton"
                }))
              : (_openBlock(), _createBlock(_component_Avatar, {
                  key: 1,
                  name: _ctx.state.firstName,
                  imageLink: _ctx.user.avatar,
                  size: "xlarge"
                }, null, 8, ["name", "imageLink"])),
            (!_ctx.isVisitorView)
              ? (_openBlock(), _createElementBlock("button", _hoisted_2, [
                  _createElementVNode("input", {
                    type: "file",
                    accept: "image/*",
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateProfilePicture && _ctx.updateProfilePicture(...args))),
                    disabled: _ctx.loadingUpdateImage,
                    class: _normalizeClass({ 'avatar__button--allowed': !_ctx.loadingUpdateImage })
                  }, null, 42, _hoisted_3),
                  _createVNode(_component_Icon, {
                    strokeColor: "var(--secondary)",
                    size: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Camera)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(`${_ctx.state.firstName} ${_ctx.state.lastName}`), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('student')) + " " + _toDisplayString(_ctx.course), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state, (value, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-d-flex p-flex-column",
              key: key
            }, [
              _createVNode(_component_custom_transition, null, {
                default: _withCtx(() => [
                  (_ctx.editingProfile)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (key === 'hasBeca')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                          : (key === 'country')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(`${_ctx.validations[key]?.$silentErrors.length ? 'container-input-select-error' : 'container-select-input'}`),
                                style: _normalizeStyle(
                _ctx.filteredCountry.length
                  ? _ctx.validations[key]?.$silentErrors.length
                    ? 'min-height: 120px;'
                    : 'min-height: 96px;'
                  : _ctx.validations[key]?.$silentErrors.length
                  ? 'height: 120px;'
                  : 'height: 96px;'
              )
                              }, [
                                _createElementVNode("label", _hoisted_9, [
                                  _createTextVNode(_toDisplayString(_ctx.t('cardSections.country')), 1),
                                  _hoisted_10
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("span", _hoisted_12, [
                                    _createVNode(_component_InputText, {
                                      class: "input-form-student",
                                      id: "searchBar",
                                      type: "text",
                                      autocomplete: "off",
                                      modelValue: _ctx.searchCountry,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchCountry) = $event)),
                                      onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchCountries())),
                                      placeholder: _ctx.t('cardSections.placeholder.country'),
                                      disabled: _ctx.isItemSelected
                                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                                  ]),
                                  _createElementVNode("p", {
                                    class: "delete-option",
                                    style: _normalizeStyle(_ctx.isItemSelected ? 'display: inline;' : 'display: none;'),
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteSelectionCountry()))
                                  }, _toDisplayString(_ctx.t('cardSections.erase')), 5)
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["search-result-container", { 'disable-results': _ctx.isItemSelected }]),
                                  style: _normalizeStyle(_ctx.filteredCountry.length ? 'opacity: 1;' : 'opacity: 0;')
                                }, [
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountry, (country) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: country,
                                        class: "search-result-container__item",
                                        onClick: ($event: any) => (_ctx.selectItemCountry(country))
                                      }, _toDisplayString(country.country), 9, _hoisted_13))
                                    }), 128)),
                                    (_ctx.filteredCountry.length > 9)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_14))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 6),
                                (_ctx.validations[key]?.$silentErrors.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.t('cardSections.error.incomplete')), 1))
                                  : _createCommentVNode("", true)
                              ], 6))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(`${_ctx.validations[key]?.$silentErrors.length ? 'container-input-error' : 'container-input'}`)
                              }, [
                                _createElementVNode("label", null, [
                                  _createTextVNode(_toDisplayString(_ctx.t(`cardSections.${key}`)), 1),
                                  (['curp', 'firstName', 'lastName', 'email'].includes(key))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, " *"))
                                    : _createCommentVNode("", true)
                                ]),
                                (key === 'bday')
                                  ? (_openBlock(), _createBlock(_component_Calendar, {
                                      key: 0,
                                      id: key,
                                      name: key,
                                      modelValue: _ctx.state[key],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.state[key]) = $event),
                                      maxDate: new Date(),
                                      dateFormat: "dd/mm/yy",
                                      showIcon: true,
                                      manualInput: false,
                                      placeholder: "DD/MM/AA"
                                    }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue", "maxDate"]))
                                  : (['phone'].includes(key))
                                    ? (_openBlock(), _createBlock(_component_InputNumber, {
                                        key: 1,
                                        id: key,
                                        name: key,
                                        modelValue: _ctx.state[key],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.state[key]) = $event),
                                        placeholder: _ctx.t(`cardSections.${key}`),
                                        class: _normalizeClass(` ${_ctx.validations[key]?.$silentErrors.length ? 'input-form-student-error' : 'input-form-student'}`),
                                        mode: "decimal",
                                        useGrouping: false
                                      }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue", "placeholder", "class"]))
                                    : (_openBlock(), _createBlock(_component_input_text, {
                                        key: 2,
                                        id: key,
                                        name: key,
                                        modelValue: _ctx.state[key],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.state[key]) = $event),
                                        placeholder: key === 'curp' ? _ctx.t('cardSections.placeholder.docNumber') : _ctx.t(`cardSections.${key}`),
                                        class: _normalizeClass(` ${_ctx.validations[key]?.$silentErrors.length ? 'input-form-student-error' : 'input-form-student'}`),
                                        disabled: ['email', 'hasBeca'].includes(key)
                                      }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue", "placeholder", "class", "disabled"])),
                                (['curp'].includes(key))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.t('cardSections.input.identityDocTypes')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.validations[key]?.$silentErrors.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.t('cardSections.error.incomplete')), 1))
                                  : _createCommentVNode("", true)
                              ], 2))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (key === 'country' || key === 'email')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t(`cardSections.${key}`)), 1),
                              _createElementVNode("span", _hoisted_21, _toDisplayString(key === 'country' ? _ctx.searchCountry : value), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]),
        (_ctx.isVisitorView && _ctx.information.chatLink)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              style: {"text-decoration":"none"},
              to: _ctx.information.chatLink
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  label: _ctx.t('visitorView.button'),
                  class: "secondary full-width"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["to"]))
          : (!_ctx.editingProfile && !_ctx.isVisitorView)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                onClick: _ctx.handleToggleEdit,
                label: _ctx.t('editProfile.button'),
                class: "secondary full-width"
              }, null, 8, ["onClick", "label"]))
            : (!_ctx.isVisitorView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["style"])
  ], 64))
}